/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const ThirstIcon = props => {
	const { color = '' } = props
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 50 50'
			style={{
				enableBackground: 'new 0 0 50 50'
			}}
			xmlSpace='preserve'
			width='1em'
			height='1em'
			fill={color}
			{...props}
		>
			<path d='M34 23.1c-2-.1-3.7-1.4-4.3-3.2-.2-.5-.3-1.1-.3-1.6-.1-.6.4-1.1 1-1.2s1.1.4 1.2 1v.1c0 1.5 1.2 2.7 2.7 2.8.6 0 1 .4 1.1 1v.2c0 .6-.5 1.1-1.1 1l-.3-.1zM15.4 23c-.5.1-1-.2-1.2-.6s-.1-.9.3-1.2c.3-.2.6-.3 1-.3.5-.1.9-.3 1.3-.5.7-.4 1.2-1.2 1.2-2.1 0-.6.4-1.1 1-1.2.2 0 .3 0 .5.1.4.2.7.6.6 1 0 1.7-.9 3.2-2.4 4.1-.6.4-1.5.7-2.3.7z' />
			<path d='M25.6.9C18.4.9 12 4 7.6 8.9c.3.5.7.9 1 1.4 4.1-4.7 10.2-7.7 17-7.7 12.5 0 22.6 10.1 22.6 22.6S38.1 47.8 25.6 47.8C13.1 47.8 3 37.7 3 25.2c0-.6 0-1.2.1-1.8-.6-.3-1.1-.6-1.6-1-.1.9-.2 1.8-.2 2.8 0 13.4 10.9 24.3 24.3 24.3s24.3-10.9 24.3-24.3C49.8 11.8 39 .9 25.6.9z' />
			<path d='M31.4 29.9c-1.5 1.4-3.1 2.5-4.9 3.5-1.6 1.2-3.4 2.1-5.3 2.8 1.5-1.4 3.2-2.5 5-3.5 1.5-1.2 3.3-2.1 5.2-2.8zm-5 3.4c1.2-.6 2.2-1.4 3.2-2.3-1.2.4-2.4 1.1-3.5 1.8-1.2.6-2.2 1.4-3.2 2.3 1.3-.4 2.4-1.1 3.5-1.8z' />
			<path d='m21.3 36.7-.5-.9c1.5-1.4 3.2-2.6 5.1-3.6 1.6-1.1 3.4-2.1 5.4-2.8l.5.9c-1.5 1.4-3.2 2.6-5 3.6-1.7 1.1-3.5 2.1-5.5 2.8zM10.3 14.9c-1-1.8-2.1-3.6-3.3-5.3-.5-.7-1.1-.9-1.6-.9-.6 0-1.2.4-1.7 1-1.2 1.6-2.2 3.2-3.2 4.9-.9 1.7-.8 3.5.1 5 1 1.5 2.7 2.4 4.7 2.4s3.7-.9 4.6-2.4c1.1-1.3 1.2-3 .4-4.7z' />
		</svg>
	)
}

export default ThirstIcon
